import bahamutBanner from './assets/bahamut-banner.png';
import iotaBanner from './assets/iota-banner.png';
import xdcRwaBanner from './assets/xdc-rwa-banner.png';
import { IB2BReferralProgram } from './types';

export enum ApplyReferralCodeErrorCode {
  ALREADY_USED = 'already-used',
  EXPIRED = 'referral-code-expired',
  NOT_FOUND = 'not-found',
}

export const MIN_REFERRAL_CODE_LENGTH = 3;
export const MAX_REFERRAL_CODE_LENGTH = 32;

export const B2B_REFERRAL_PROGRAMS: IB2BReferralProgram[] = [
  {
    banner: bahamutBanner,
    blockchains: 'Bahamut',
    bundleId: 'e69a8078-c1be-44ab-8364-eb679d642c13',
    customDescription: `Thank you for using your Bahamut community referral code! Please proceed to have complimentary premium access to the <b>Bahamut Blockchain</b> through <b>Ankr</b> nodes for the upcoming hackathon. Build innovative applications on <b>Bahamut's PoSA</b> consensus blockchain during Paris Blockchain Week and compete for a share of the <b>$10,000</b> prize pool.`,
    customTitle: 'Bahamut Hackathon - Paris Blockchain Week Edition',
    name: 'Bahamut Hackathon',
    referralCode: 'Bahamut25',
  },
  {
    banner: iotaBanner,
    blockchains: 'IOTA Testnet',
    bundleId: 'e907cc93-c845-48a9-9248-118021491fe2',
    customTitle: 'Moveathon with Ankr Referral Program',
    name: 'Moveathon',
    referralCode: 'IOTAMoveathonAPAC25',
  },
  {
    banner: xdcRwaBanner,
    blockchains: 'XDC Network',
    bundleId: 'e524f332-9728-4818-9820-63e89c105610',
    customBlockchainsDescription:
      'Free access to interact with <b>XDC Network</b>',
    customDescription:
      'Congratulations!<br /><br />As part of the <b>XDC Enterprise RWA Accelerator Program</b>, you now have exclusive access to <b>Ankr Premium RPCs</b> to power your blockchain project with enhanced performance, reliability, and security.<br /><ul style="padding-left: 20px"><li>Free access to interact with <b>XDC Network</b></li><li>Superior rate limits: 1,500 requests per second</li><li>Usage stats dashboard / HTTPS & WSS / Standard-Trace-Debug calls</li></ul>',
    customTitle: 'XDC RWA Accelerator Powered by Ankr RPCs',
    name: 'XDC RWA Accelerator',
    referralCode: 'XDCRWA25',
  },
  {
    banner: xdcRwaBanner,
    blockchains: 'Somnia Testnet',
    bundleId: 'e0dd86b9-1065-4342-9bb2-4ceb05bb19a0',
    name: 'Somnia Testnet Hackathon',
    referralCode: 'SomniaTestnet2',
  },
];
